import { useState } from "react";

export default function useOsmProviders() {
  const streets =
    "https://api.maptiler.com/maps/streets-v2/256/{z}/{x}/{y}.png?key=RZa6qVMoHdX3LB8nCD2U";
  const satellite =
    "https://api.maptiler.com/maps/cadastre-satellite/256/{z}/{x}/{y}.png?key=RZa6qVMoHdX3LB8nCD2U";
  const lbmDark =
    "https://api.maptiler.com/maps/ch-swisstopo-lbm-dark/256/{z}/{x}/{y}.png?key=RZa6qVMoHdX3LB8nCD2U";
  const [maptilerURL, setMaptilerURL] = useState(streets);

  return {
    maptiler: {
      url: maptilerURL,
      attribution: "https://www.openstreetmap.org/copyright",
    },
    maptilerURL,
    setMaptilerURL,
    streets,
    satellite,
    lbmDark,
  };
}
